// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Debug_overlay__SZwFO","detailsSection":"Debug_detailsSection__vJYFV"};